import type { IRootState } from "../app/store";

export const selectHighlightedRoomNumber = (state: IRootState) =>
  state.design.highlightedRoomNumber;

export const selectIsRoomHighlightActive = (state: IRootState) =>
  selectHighlightedRoomNumber(state) != null;
